// extracted by mini-css-extract-plugin
export var banner = "_ta-0";
export var settingRow = "_ta-2";
export var titleIcon = "_ta-1";